<template>
<div class="cloud_container">
    <h4>Voici le nom des 20 derniers sites internet frauduleux mis au jour par les autorités :</h4>
    <!--<highcharts class="myCloud" ref="myCloud" :options="chartOptions" id="myCloud"></highcharts>-->
    <div class="site_name_list">
       <!-- <li v-for="i in $store.state.name[0:9]" :key="i">-->
       <div>

           <p>1  - {{this.$store.state.name[0][0] }}</p>
           <p>2  - {{this.$store.state.name[1][0] }}</p>
           <p>3  - {{this.$store.state.name[2][0] }}</p>
           <p>4  - {{this.$store.state.name[3][0] }}</p>
           <p>5  - {{this.$store.state.name[4][0] }}</p>


               <p>6  - {{this.$store.state.name[5][0] }}</p>
               <p>7  - {{this.$store.state.name[6][0] }}</p>
               <p>8  - {{this.$store.state.name[7][0] }}</p>
               <p>9  - {{this.$store.state.name[8][0] }}</p>
               <p>10 - {{this.$store.state.name[9][0] }}</p>

       </div>

        <div>
            <p>11 - {{this.$store.state.name[10][0] }}</p>
            <p>12 - {{this.$store.state.name[11][0] }}</p>
            <p>13 - {{this.$store.state.name[12][0] }}</p>
            <p>14 - {{this.$store.state.name[13][0] }}</p>
            <p>15 - {{this.$store.state.name[14][0] }}</p>

           <p>16 - {{this.$store.state.name[15][0] }}</p>
           <p>17 - {{this.$store.state.name[16][0] }}</p>
           <p>18 - {{this.$store.state.name[17][0] }}</p>
           <p>19 - {{this.$store.state.name[18][0] }}</p>
           <p>20 - {{this.$store.state.name[19][0] }}</p>
       </div>


        <!--  </li>-->
        </div>
</div>

 </template>

 <script>
     export default {
         data() {
               return {
                  chartOptions: {
                     colors:['#8DB3E0'],
                     title:false,
                     styledMode:true,
                      spacingBottom:0,
                      spacingTop: 0,
                       spacingLeft:0,
                       spacingRight:0,
                        height:'80%',
                        series: [{
                         type: 'wordcloud',
                         data: [
                         ],
                         rotation: {
                             from: 0,
                             to: 0,
                         },
                            style:{
                                fontSize:'60px'
                            }

                     }],
                     tooltip: {
                         enabled:false
                     }
                 },
                   responsive:{
                       rules: [{
                           condition:{
                               maxWidth:500
                           },
                         chartOptions: {
                               colors:['#8DB3E0'],
                               title:false,
                               styledMode:true,
                               spacingBottom:0,
                               spacingTop: 0,
                               spacingLeft:0,
                               spacingRight:0,
                               width:'100%',
                               height:'100%',
                               series: [{
                                   type: 'wordcloud',
                                   data: [
                                   ],
                                   rotation: {
                                       from:0,
                                       to:0,
                                   },
                                  style:{
                                       fontSize:'60px'
                                   }
                               }],
                               tooltip: {
                                   enabled:false
                               }

                       }
                       }]
                 }




               }
         },
        /* mounted() {
             const _self = this
             setTimeout(function () {
                 _self.myname = _self.$store.state.name
             }, 300)



             setTimeout(function () {
                 _self.$refs['myCloud'].chart.series[0].setData(_self.$store.state.name)
             }, 1500)
         },*/
     }

 </script>

 <style>


 .cloud_container h4{
     width:80vw;
     text-align: center;
 }


 .cloud_container{
     height:70vh;
     display:flex;
     flex-direction:column;
     align-items:center;
     justify-content:center;
 }

.site_name_list{
     height:40vh;
     width:60vw;
     display:flex;
     align-items:center;
     justify-content:space-around;
 }

div.site_name_list p{
    margin-bottom:1vh;
    font-weight: 700;
}

 /*
 .cloud_container{
     height:70vh;
     display:flex;
     flex-direction:column;
     align-items:center;
     justify-content:center;
   }

 */



 @media screen and (max-width:1000px) and (min-width:501px){
     .cloud_container{
         margin-top:10vh;
         height:60vh;
         display:flex;
         flex-direction:column;
         align-items:center;
         justify-content: center;
     }

 }





@media screen and (max-width:500px) and (min-width:401px){
    .cloud_container{
     height:60vh;
     display:flex;
     flex-direction:column;
     align-items:center;
     justify-content: center;
     }

 }
 @media screen and (max-width:1000px){
     .cloud_container{
         margin-top:10vh;
         height:70vh;
         display:flex;
         flex-direction:column;
         align-items:center;
         justify-content:center;
     }
     .site_name_list{
         height:50vh;
         width:90vw;
         display:flex;
         align-items:center;
         justify-content:space-around;
     }


 }


 .myCloud{
 height:auto;
 width:50%;
 }

 @media screen and (max-width:1000px){
     .myCloud{
     height:50vh;
     width:100vw;
     }

     div.myCloud .highcharts-container{
         height: 100%;
         width: 100vw;

     }

     div.myCloud .highcharts-background {
         height: 80%;
         width: 100vw;

     }

     div.myCloud .highcharts-root {
         height: 100%;
         width:100vw;
         transform:translateY(-5vh);
     }


 }






 </style>